var _style, _path, _text;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOweMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1oweMoney",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 155.6",
    style: {
      enableBackground: "new 0 0 156 155.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.oweMoney{fill:#FF5033;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{font-family:'HYk1gj';}\n\t.st3{font-size:106.7121px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "oweMoney",
    d: "M30,2.8h96c15.1,0,27.3,12.2,27.3,27.3v96c0,15.1-12.2,27.3-27.3,27.3H30c-15.1,0-27.3-12.2-27.3-27.3v-96 C2.7,15.1,14.9,2.8,30,2.8z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0073 0 0 1 24.4048 112.2744)",
    className: "st1 st2 st3"
  }, "\u6B20")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOweMoney);
export default __webpack_public_path__ + "static/media/oweMoney.a519e27b.svg";
export { ForwardRef as ReactComponent };